import React from 'react';
import { ReactComponent as SaleOrRentIcon } from '../../../assets/icons/venta_renta.svg';
import { ReactComponent as DevelopmentsIcon } from '../../../assets/icons/desarrollos.svg';
import { sendCustomTrackingInfo } from '@panel/commons';
import { useSelector } from 'react-redux';
import { bumexFeaturesKeys } from '@panel/core/src/constants/bumexFeatures';
import { bumexFeatureSelectors } from '@panel/core/src/state/ducks/bumexFeatures';

/**
 * @description Hook para obtener el estado de la BumexFeature NEW_REALESTATE_PRO_PUBLISHER_ENABLE
 * @returns {boolean} - Estado de la feature flag
 */
export const useNewPublisherEnabled = () => {
  const { bumexFeatures } = useSelector(bumexFeatureSelectors.getBumexFeatureState);
  return bumexFeatures.get(bumexFeaturesKeys.NEW_REALESTATE_PRO_PUBLISHER_ENABLE) || false;
};

export const options = [
  {
    id: 'sale_or_rent',
    ctaText: 'professionalPubli.publicationType.card.ventaRenta.title',
    description: 'professionalPubli.publicationType.card.ventaRenta.description',
    icon: <SaleOrRentIcon />,
    url: '/publicador-profesionales/main',
    oldUrl: 'publicar.bum?propiedad=inmueble'
  },
  {
    id: 'developments',
    ctaText: 'professionalPubli.publicationType.card.desarrollos.title',
    description: 'professionalPubli.publicationType.card.desarrollos.description',
    icon: <DevelopmentsIcon />,
    url: 'publicar.bum?propiedad=desarrollo'
  }
];

/**
 * @description Redirects users based on publication type and site configuration.
 * @param {object} option
 * @param {object} history
 * @param {boolean} isNewPublisherEnabled - BumexFeature flag for new publisher
 * @returns {void}
 */
export const handleRedirect = (option, history, isNewPublisherEnabled = false) => {
  const isSaleOrRent = option.id.includes('sale_or_rent');
  const isDevelopments = option.id.includes('developments');

  sendCustomTrackingInfo({
    event: 'trackEvent',
    eventCategory: 'Publicacion',
    eventAction: 'Seleccion operacion',
    eventLabel: isSaleOrRent ? 'Alquiler Venta' : 'Emprendimiento'
  });

  if (isSaleOrRent && isNewPublisherEnabled) {
    history.push(option.url);
  } else if (isSaleOrRent) {
    window.location.href = option.oldUrl;
  } else if (isDevelopments) {
    window.location.href = option.url;
  }
};
